// Mouse-following image reveal for the "Still Looking?" text links
// Mirrors the inline script Webflow embeds in section_cta37.
export default function initExploreCta() {
    // Only runs on desktop (live disables hover states below 992px)
    if (!window.matchMedia('(min-width: 992px)').matches) return;

    document.querySelectorAll('[data-explore-cta]').forEach((component) => {
        const links = component.querySelectorAll('[data-explore-link]');
        if (!links.length) return;

        links.forEach((link) => {
            const wrapper = link.querySelector('[data-explore-image]');
            if (!wrapper) return;

            const show = () => { wrapper.style.display = 'block'; };
            const hide = () => { wrapper.style.display = 'none'; };

            const move = (e) => {
                const w = wrapper.offsetWidth;
                const h = wrapper.offsetHeight;
                // Horizontally center on cursor, vertically float 30px above it
                const x = e.clientX - w / 2;
                const y = e.clientY - h - 30;
                wrapper.style.transform = `translate(${x}px, ${y}px)`;
            };

            link.addEventListener('mouseenter', show);
            link.addEventListener('mousemove', move);
            link.addEventListener('mouseleave', hide);
        });
    });
}
